/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
//material
import ColorPicker from 'material/embeds/colorpicker/colorpicker';
import { Title, Note, Tip, Icon, Switch, TextField } from '@insticator/insticator-ui'; // iui-material
//utils
import { debounce } from '@insticator/insticator-ui'; // iui-utils
import { validation } from 'utils/validation';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/cardproperties/storyproperties/storyproperties_styles';



/* ========== ~~~~~~~~~~ EMBED STORY PROPERTIES ~~~~~~~~~~ ========== */
class StoryProperties extends Component {

    constructor(props) {
        super(props);
        this.state = {
            autopopulate: true
        }
    }

    handleChange = (event) => {
        if (this.processInput(event.target.value) && this.state.autopopulate)
            this.processStoryURL(event.target.value)
    }

    switchToggle = (value, on) => {
        this.setState({ autopopulate: on });
    }

    processInput = (value) => {
        this.props.setStoryProperty(this.props.contentId, 'url', value)
        const isURLValid = validation.storyURL.test.test(value);
        this.props.setStoryProperty(this.props.contentId, 'isURLValid', isURLValid)
        return isURLValid;
    }

    processStoryURL = debounce((value) => this.props.applyStoryURL(this.props.contentId, value), 500);

    showPlacement = () => this.props.location === 'in-content' ? 'incontent' : 'rail';
    setBackgroundColor = (color) => (this.props.setCurrentUniqueProperty(this.props.contentId, 'backgroundColor', color));

    render() {
        return (
            <div className={`storyproperties ${this.showPlacement()} ${this.props.classes.storyproperties} validurl-${this.props.isURLValid}`}>
                <Title>
                    <h4>Story click-through URL</h4>
                </Title>
                <Note>
                    <p>(link opens in new tab)</p>
                </Note>
                <div className={`autopopulateToggle`}>
                    <p>Autopopulate <Tip space={`left`} content={`Enter your story click-through URL here and we will automatically add a headline/image if we find one.`} /></p>
                    <Switch variant={'secondary'} value={null} on={this.state.autopopulate} handleClick={this.switchToggle} />
                </div>
                <div className={`storyurl`}>
                    <TextField type={`text`}
                        name={`storyURL`}
                        icon={this.props.storyURLDataReceived === false ? <Icon name={`circle-notch`} animation={'spin'} /> : <Icon name={`link`} />}
                        value={this.props.url}
                        valid={this.props.isURLValid}
                        handleChange={this.handleChange}
                        placeholder={this.props.partnerLogo.url === null ? `ex http://www.xyz.com` : this.props.partnerLogo.url}
                        required />
                </div>
                <div className={`background`}>
                    <Title>
                        <h4>Background Color:</h4>
                    </Title>
                    <ColorPicker fadeInRight={true} color={this.props.backgroundColor} processColorUpdate={this.setBackgroundColor} />
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(StoryProperties);
